import { useState } from 'react';
import { MoTableData, MyOrder, SearchRequest } from 'ts/shared/interfaces/MOResponse';
import MoSearch2 from './MoSearch2';
import MoTabs2 from './MoTabs2';
import { formatMyOrder } from 'utils/shared/my-order';
import { I18nextProvider } from 'react-i18next';
import { MoContext } from 'contexts/MoContext';
import { i18nMainMOPage2 } from 'utils/shared/utils';

const MainMOPage2 = () => {
  const [tableData, setTableData] = useState<MoTableData[]>([]);
  const [myOrders, setMyOrders] = useState<MyOrder[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [model, setModel] = useState<SearchRequest>();
  const [sort, setSort] = useState<{ field: string; direction: string }>({
    field: '',
    direction: '',
  });
  const [visibleRows, setVisibleRows] = useState<number[]>([]);
  const [activeOrder, setActiveOrder] = useState<MyOrder>();
  const [mainFilter, setMainFilter] = useState('');
  const [modelOptions, setModelOptions] = useState<SearchRequest>();


  const onUpdateRow = (row: MyOrder) => {
    setTableData((prev) => {
      const formattedMyOrder = formatMyOrder(row);

      const index = prev.findIndex((item) => item.segmentId === formattedMyOrder.segmentId);
      if (index === -1) {
        return prev;
      }
      return prev.slice(0, index).concat(formattedMyOrder, prev.slice(index + 1));
    });
    setMyOrders((prev) => {
      const myOrderIndex = prev.findIndex(
        (item) => item.fullSegment.orderSegId === row.fullSegment.orderSegId
      );
      if (myOrderIndex === -1) {
        return prev;
      }
      return prev.slice(0, myOrderIndex).concat(row, prev.slice(myOrderIndex + 1));
    });

    if (row.fullSegment.orderSegId === activeOrder?.fullSegment.orderSegId) {
      setActiveOrder(row);
    }
  };
  return (
    <I18nextProvider i18n={i18nMainMOPage2}>
      <MoContext.Provider
        value={{
          searchModel: model,
          setSearchModel: setModel,
          sort,
          setSort,
          visibleRows,
          setVisibleRows,
          mainFilter,
          setMainFilter,
          modelOptions,
          setModelOptions,
          activeOrder,
          setActiveOrder,
        }}
      >
        <div className="mo-wrapper mo-wrapper2">
          <MoSearch2
            tableData={tableData}
            setSearchLoading={setSearchLoading}
            searchLoading={searchLoading}
            onChangeSearch={(tableData, updatedMyOrders) => {
              setTableData(tableData);

              const newActiveOrder = updatedMyOrders?.find((item) => item.fullSegment.orderSegId === activeOrder?.fullSegment.orderSegId);
              if (newActiveOrder) {
                setActiveOrder(newActiveOrder);
              }
            }}
            setMyOrders={setMyOrders}
          />

          <MoTabs2
            tableData={tableData}
            searchLoading={searchLoading}
            onUpdateMyOrder={onUpdateRow}
            myOrders={myOrders}
            onChangeTableData={setTableData}
            activeOrder={activeOrder}
            setActiveOrder={setActiveOrder}
          />
        </div>
      </MoContext.Provider>
    </I18nextProvider>
  );
};

export default MainMOPage2;
